/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from "vue-property-decorator";
import {getFinanceOrderListById} from '@/api/common'
import {formatDate} from "@/utils/timeFilter";
import {delNullProperty} from "@/utils";

@Component({})
export default class GiveStudent extends Vue {
    // data
    tableData = []
    id = ''
    name = ''
    type = ''
    userName = ''
    source = ''
    createdAt = []
    marketCooperationSourceList = [
        {label: 'BD自开拓', value: '0'},
        {label: '市场自开拓', value: '1'},
        {label: 'KA战略合作', value: '2'},
        {label: '高校业务部门', value: '3'},
        {label: '咨询平台', value: '4'},
        {label: '咨询自渠道', value: '5'}
    ]
    page = 1
    pageSize = 20
    total = 0
    loading = false

    created(){
      const obj = this.$route.query ;
      this.name = obj.name as string
      this.type = obj.type as string;
      this.userName = obj.userName as string;
      // this.source = obj.source === '0' ? 'BD自开拓' : obj.source === '1' ? '市场自开拓' :  obj.source === '2' ? 'KA战略合作' :'高校业务部门'
        this.marketCooperationSourceList.forEach(item => {
            if (item.value === obj.source) {
                this.source = item.label
            }
        })
      this.id = obj.id as string
      this.getTableData()
    }

    async getTableData() {
        this.loading = true
        await getFinanceOrderListById(delNullProperty({
            id: Number(this.id),
            createdAt: this.changeTime(this.createdAt),
            limit: this.pageSize,
            page: this.page,
        })).then(res => {
            const {financeOrderList, allNum} = res as any
            this.loading = false
            this.tableData = financeOrderList
            this.total = allNum
        }).catch(err => {
            this.loading = false
        })
    }

    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }
    //createdAt: this.changeTime(this.createdAt as Date[]), //提醒时间

    getSummaries(param: any) {
        const { columns, data } = param;
        let sums: any = [];
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map((item: any) => Number(item[column.property]));
          if (!values.every((value: any) => isNaN(value))) {
            sums[index] = values.reduce((prev: any, curr: any) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev;
              }
            }, 0);
            sums[index]
          } else {
            sums[index] = '———';
          }
        });
        sums = sums.map(item => {
            if(typeof item === 'number') {
              return item.toLocaleString()
            } else {
              return item
            }
        });
        return sums;

    }


    handlechangePage(page: number) {
        this.page = page
        this.getTableData()
    }

    handleChangePageSize(size: number) {
        this.pageSize = size
        this.getTableData()
    }


}
